'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ContactThumbnail = require('./ContactThumbnail');

var _ContactThumbnail2 = _interopRequireDefault(_ContactThumbnail);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RecipientHeader = function RecipientHeader(_ref) {
	var thumbnailUrl = _ref.thumbnailUrl,
	    header = _ref.header,
	    amount = _ref.amount,
	    textColor = _ref.textColor;

	var headerStyles = {
		marginBottom: 10,
		color: textColor
	};

	return _react2.default.createElement(
		'div',
		null,
		_react2.default.createElement(_ContactThumbnail2.default, { thumbnailUrl: thumbnailUrl }),
		_react2.default.createElement('h3', { className: 'vx_text-3_lighter', style: headerStyles, dangerouslySetInnerHTML: { __html: header } }),
		amount
	);
};

RecipientHeader.propTypes = {
	thumbnailUrl: _react.PropTypes.string,
	header: _react.PropTypes.string.isRequired,
	amount: _react.PropTypes.element.isRequired,
	textColor: _react.PropTypes.string
};

exports.default = RecipientHeader;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/guest-payment/dist/components/RecipientHeader.js
// module id = 392
// module chunks = 6